import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { DisclaimerGeneratorComponent } from './disclaimer-generator.component';
import { DisclaimerPreviewComponent } from './disclaimer-preview/disclaimer-preview.component';
import { DisclaimerCreateEditComponent } from './disclaimer-create-edit/disclaimer-create-edit.component';

@NgModule({
  declarations: [DisclaimerGeneratorComponent, DisclaimerPreviewComponent, DisclaimerCreateEditComponent],
  imports: [
    CommonModule,
    FormsModule,
    ColorPickerModule,
    TooltipModule,
    NgxJsonViewerModule,
    NgMultiSelectDropDownModule.forRoot(),
  ],
  exports: [DisclaimerGeneratorComponent],
})
export class DisclaimerGenerationModule {}
